import { render, staticRenderFns } from "./inventory_index.vue?vue&type=template&id=28919700&scoped=true"
import script from "./inventory_index.vue?vue&type=script&lang=js"
export * from "./inventory_index.vue?vue&type=script&lang=js"
import style0 from "./inventory_index.vue?vue&type=style&index=0&id=28919700&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28919700",
  null
  
)

export default component.exports